import React, { Component } from 'react';

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import FAQ from '../../components/FAQ';
import ServicePageOtherLinks from '../../components/ServicePageOtherLinks';
import ServicePage23WhyChoose from '../../components/ServicePage23WhyChoose';
import Testimonial from '../../components/Testimonial';
import ServicePageForm from '../../components/ServicePageForm';

import Banner from '../../components/Banner'

import { Link } from "react-router-dom";

import References from '../../components/References';

// import Feature from '../../components/Feature'

// import './App.scss';

class ServicesPage2_3_1 extends Component {
  render() {
    return (
      <div className="page homepage">       
        <Banner>
          <h2>Asiantuntijapalvelut</h2>
        </Banner>
        <Container className="intro p-t-100 p-b-50 text-center" id="content">
          <Row className="p-b-100">
            <Col sm={{ span: 8, offset: 2}}>
              <h1>TAPAHTUMAN TURVALLISUUS- JA PELASTUSSUUNNITELMA</h1>
              <h3>HUOLELLINEN SUUNNITTELU, TURVALLINEN TOTEUTUS</h3>
              <p>
                Tapahtuman turvallisuus- ja pelastussuunnitelman avulla pyritään ennaltaehkäisemään riskejä ja varmistamaan nopea ja tehokas reagointi mahdollisiin vaaratilanteisiin tai onnettomuuksiin. Laadukkaan suunnitelman muodostaminen edellyttää tiivistä yhteistyötä eri sidosryhmien, kuten viranomaisten, turvallisuushenkilöstön ja tapahtumanjärjestäjien kesken.
              </p>

              <p className="p-b-50">
                Tapahtuman turvallisuus- ja pelastussuunnitelma tulee laatia mikäli tapahtumassa arivoidaan olevan läsnä samanaikaisesti yli 200 henkilöä, tapahtumassa käytetään avotulta, ilotulitteita tai muita pyroteknisiä tuotteita taikka erikoistehosteina palo- ja räjähdysvaarallisia kemikaaleja, tapahtumapaikan poistumisjärjestelyt poikkeavat tavanomaisesta tai tapahtuman luonne aiheuttaa erityistä vaaraa ihmisille.
              </p>

              <Link className="btn-grey" to="/tajouspyynto">PYYDÄ TARJOUS</Link>
            </Col>
          </Row>
        </Container>

        <Container fluid className="p-b-25 p-t-25 bg-gray text-center">
          <Row>
            <Col>
              <h3>Myös he luottavat meihin turvallisuusasioissa:</h3>
              <References />
            </Col>
          </Row>
        </Container>

        <Container className="p-t-50 p-b-50">
          <Row>
            <Col sm={{ span: 8, offset: 2 }}>
              <h3 className="p-b-25">Palvelun kuvaus</h3>
              <h4>Alkukartoitus</h4>
              <p>Ennen tapahtuman turvallisuus- ja pelastussuunnitelman laatimisen aloittamista kartoitetaan tapahtuman luonne, erityispiirteet, tapahtuma-alue ja tapahtumaan kohdistuvat riskit.</p>

              <h4>Tiedon kerääminen</h4>
              <p>Turvallisuus- ja pelastussuunnitelman laatimiseen tarvittavat tiedot kerätään tapahtumajärjestäjältä, viranomaisilta ja muilta sidosryhmiltä.</p>

              <h4>Riskien arviointi</h4>
              <p>Tapahtumaan kohdistuvien riskien arviointi yhdessä järjestäjä organisaation kanssa.</p>

              <h4>Suunnitelman laatiminen</h4>
              <p>Turvallisuus- ja pelastussuunnitelma laaditaan kerättyyn tietoon ja materiaaliin perustuen. Suunnitelmaan sisällytetään toimintaohjeet erilaisiin tilanteisiin reagoimiseksi.</p>

              <h4>Suunnitelman hyväksyminen</h4>
              <p>Turvallisuus- ja pelastussuunnitelma käydään läpi tapahtuman järjestäjän ja viranomaisten kanssa.</p>

              <h4>Perehdytys</h4>
              <p>Turvallisuus- ja pelastussuunnitelma perehdytetään koko tapahtumahenkilöstölle.</p>
            </Col>
          </Row>
        </Container>

        <ServicePageOtherLinks>
          <Link to="/jarjestyksenvalvonta/tapahtumaturvallisuus">Tapahtumaturvallisuus</Link>
          <Link to="/asiantuntijapalvelut/turvallisuuspaallikko">Turvallisuuspäällikkö</Link>
          <Link to="/asiantuntijapalvelut/tapahtuman-turvallisuus-ja-pelastussuunnitelma">Tapahtuman turvallisuus-ja pelastussuunnitelma</Link>
          <Link to="/asiantuntijapalvelut/ensiapusuunnitelma">Tapahtuman ensiapusuunnitelma</Link>
          <Link to="/muutpalvelut/ensiapu">Ensiapu</Link>
          <Link to="/muutpalvelut/liikenteenohjaus">Liikenteenohjaus</Link>
          <Link to="/muutpalvelut/vaatesailytys">Vaatesäilytys</Link>
          <Link to="/muutpalvelut/radiopuhelin">Radiopuhelimet</Link>
          <Link to="/muutpalvelut/turvatekniikka">Turvatekniikka</Link>
        </ServicePageOtherLinks>

        <ServicePage23WhyChoose />

        <Testimonial />

        <FAQ/>

        <ServicePageForm />
      </div>
    );
  }
}

export default ServicesPage2_3_1;
